const FilterTablesType = Object.freeze({
  AllSystemFilters: 1,
  MyFilters: 2,
});
export default FilterTablesType;
